import AuthGuard from "components/auth/AuthGuard";
import GuestGuard from "components/auth/GuestGuard";
import MainLayout from "layouts/MainLayout";
import React from "react";
import { NotFoundPage } from "views/404/NotFoundPage";
import ComponentsPage from "views/Components/ComponentsPage";
import LoginPage from "views/Login/LoginPage";

export interface AppRoute {
  path?: string;
  index?: boolean;
  element?: React.ReactNode;
  name?: string;
  title?: string;
  children?: AppRoute[];
  icon?: React.ReactNode;
  breadcrumb?: string;
  isAccess?: boolean;
  hidden?: boolean;
  checkIsDev?: boolean;
}

export type Route = AppRoute;

const routes: AppRoute[] = [
  {
    path: "/",
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
  },
  {
    path: "/login",
    element: (
      <GuestGuard>
        <LoginPage />
      </GuestGuard>
    ),
  },
  {
    path: "/components",
    element: <ComponentsPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export { routes };
